import { useEffect } from "react";
import MainReporting from "./MainReporting";
import { getRegions } from "redux/actions/regionActions";
import { getTransactionTypes } from "redux/actions/transactionActions";

const Reports = () => {
  useEffect(() => {
    getTransactionTypes();
    getRegions();

    // eslint-disable-next-line
  }, []);

  return <MainReporting />;
};

export default Reports;
